import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ImagePicker } from "lucy/common-components";
import * as React from "react";
import { Button, Input, Label } from "uxp/components";
import { IUIPropertyDefinition } from '../common';
import { Property } from "./common";

export function MultipleImagesProperty(title: string, props: string[], showCategoryTitle = false): IUIPropertyDefinition<string[]> {
    return {
        defaults: props,
        render: (props) => {

            const imageUrls: string[] = props.uiProps || [];

            return <div className='wd-prop-item'>
                {!!showCategoryTitle && <div className='wd-prop-item-title'>{title}</div>}

                <div className='wd-prop-item-editor'>
                    <Label>{title}</Label>
                    {!imageUrls.length && <Label>No Images were added</Label>}
                    <div>

                        {imageUrls.map((imageUrl, i) => {

                            return <div className="ui-field-config-item-row">
                                <div className="column" style={{ flexGrow: 1 }}>
                                    <ImagePicker
                                        uxpContext={props.uxpContext}
                                        imageUrl={imageUrl || ''}
                                        onChange={s => {
                                            const newImageUrls = [...imageUrls]
                                            newImageUrls[i] = s
                                            props.onChange(newImageUrls)
                                        }}
                                    />
                                </div>

                                <div className="column  action-column"
                                    style={{ marginLeft: '20px' }}
                                    onClick={() => {
                                        const newImageUrls = [...imageUrls]
                                        newImageUrls.splice(i, 1)
                                        props.onChange(newImageUrls)
                                    }}
                                >
                                    <FontAwesomeIcon icon={['fas', 'trash']} className='delete' />
                                </div>
                            </div>
                        })}
                        <Button
                            className="new-option"
                            title="Add New Image"
                            icon={"/Resources/Lucy/lucy-dashboard/assets/images/plus-rounded.svg"}
                            iconPosition="right"
                            onClick={() => {
                                const newImageUrls = [...imageUrls, '']
                                props.onChange(newImageUrls)
                            }}
                        />
                    </div>
                </div>
            </div>;
        }
    };
}